export default class AdminEmpresaForm {
    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Nueva empresa',
            method: 'POST',
            url: '/api/admin/empresas'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        let data = {
            nombre: '', url: ''
        };
        this.modal.render(this.render(data));
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar empresa',
            method: 'PUT',
            url: `/api/admin/empresas/${id}`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/empresas/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data));
            }
        });
    }

    getInputsContacto(alias) {
        return [
            {name: `nombre_${alias}`, type: 'text', text: 'Nombre', attr: ' maxlenght="250"'},
            {name: `ap_paterno_${alias}`, type: 'text', text: 'Ap. paterno', attr: ' maxlenght="250"'},
            {name: `ap_materno_${alias}`, type: 'text', text: 'Ap. materno', attr: ' maxlenght="250"'},
            {name: `correo_${alias}`, type: 'email', text: 'Correo', attr: ' maxlenght="250"'},
            {name: `telefono_${alias}`, type: 'text', text: 'Teléfono', attr: ' maxlenght="100"'},
        ];
    }

    renderInput(item, data) {
        return `<div class="row form-group my-1">
            <label for="${item.name}" class="col-form-label col col-md-4">${item.text}</label>
            <div class="col col-md-8">
                <input type="${item.type}" value="${data[item.name]}" id="${item.name}" name="${item.name}" class="form-control form-control-sm" ${item.attr}/>
            </div>
        </div>`;
    }

    render(data) {
        let myself = this;
        let inputIniciales = [
            {name: 'nombre_comercial', type: 'text', text: 'Nombre comercial', attr: ' required maxlenght="250"'},
            {name: 'razon_social', type: 'text', text: 'Razón social', attr: ' required maxlenght="250"'},
            {name: 'codigo_inicial', type: 'text', text: 'Código inicial', attr: ' maxlenght="20"'},
            {name: 'codigo_primaria', type: 'text', text: 'Código primaria', attr: ' maxlenght="20"'},
            {name: 'direccion', type: 'text', text: 'Dirección', attr: ''},
        ];

        let inputContactos = [
            {nombre: 'Director', inputs: this.getInputsContacto('director')},
            {nombre: 'Administrador 1', inputs: this.getInputsContacto('admin')},
            {nombre: 'Administrador 2', inputs: this.getInputsContacto('admin2')},
            {nombre: 'Administrador 3', inputs: this.getInputsContacto('admin3')},
        ];
        let html = '<div class="row form-group my-1"><div class="col-12"><b>Datos generales de la empresa</b></div></div>';
        inputIniciales.forEach(item => {
            html += myself.renderInput(item, data);
        });
        inputContactos.forEach(ic => {
            html += `<div class="row form-group my-1"><div class="col-12"><b>${ic.nombre}</b></div></div>`;
            ic.inputs.forEach(item => {
                html += myself.renderInput(item, data);
            });
        });
        return `<form>${html}</form>`;
    }
}
